export default (sportEventPathId, meetingId, eventId) => (
  `/sports/${sportEventPathId}/meetings/${meetingId}/events/${eventId}`
);
